export const makeVehicleColorsList = () => [
  'Amarelo',
  'Azul',
  'Bege',
  'Branca',
  'Cinza',
  'Dourada',
  'Grena',
  'Laranja',
  'Marrom',
  'Prata',
  'Preta',
  'Rosa',
  'Roxa',
  'Verde',
  'Vermelha',
  'Fantasia',
  'Outra',
];
